import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { CompanyService } from '../services/company.service';
import { DeleteButton, EditButton } from '../util/buttons';
export function CompanyCardActionButtons(_ref) {
  let {
    model,
    accountType,
    setLoading,
    refreshCompanies,
    type,
    deleteCompanyGroup
  } = _ref;
  const deleteCompany = CompanyService.useDelete(model.id, () => {}, setLoading);
  const deleteAndRefreshCompanies = async () => {
    await deleteCompany();
    refreshCompanies();
  };
  const handleDeleteCompanyGroup = async () => {
    await deleteCompanyGroup(model.id);
  };
  const to = () => {
    if (type === 'company') {
      return "/".concat(accountType, "/companies/").concat(model.id, "/edit");
    } else {
      return "/".concat(accountType, "/company_groups/").concat(model.id);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex company-card-control"
  }, /*#__PURE__*/React.createElement(EditButton, {
    as: Link,
    to: to(),
    className: "p-1 d-inline-flex me-1"
  }), accountType === 'admin' && /*#__PURE__*/React.createElement(DeleteButton, {
    className: "p-1 d-inline-flex text-warning",
    onClick: type === 'company' ? deleteAndRefreshCompanies : handleDeleteCompanyGroup
  }));
}